// @flow
import React from "react";
import fileDownload from "js-file-download";
import Types from "../actions/Types";
import Actions from "../actions/Creators";
import I18n from "../i18n/I18n";
import { put, call, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";

export default (api: Object) => {
  /* Get Requests */
  function* getRequests(action) {
    try {
      const response = yield call(api.stockRequest.getRequests, action.query);

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getRequestsSuccess(response.data));
        yield put(Actions.getStocksCount(action.query));
      } else {
        yield put(Actions.getRequestsFailure(response.data.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getRequestsFailure(error));
    }
  }
  function* watchGetRequests(): Generator<void, void, void> {
    yield takeLatest(Types.GET_REQUESTS, getRequests);
  }

  /*getPicklists */
  function* getPicklists(action) {
    try {
      const response = yield call(api.stockRequest.getPicklists, action.query);

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getPicklistsSuccess(response.data));
        yield put(Actions.getStocksCount(action.query));
      } else {
        yield put(Actions.getPicklistsFailure(response.data.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getPicklistsFailure(error));
    }
  }
  function* watchGetPicklists(): Generator<void, void, void> {
    yield takeLatest(Types.GET_PICKLISTS, getPicklists);
  }

  /*getPicklists */
  function* getPicklistItems(action) {
    try {
      const response = yield call(
        api.stockRequest.getPicklistItems,
        action.query
      );

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        if (action.query.indexOf("is_export") !== -1) {
          const params = URLSearchParams
            ? new URLSearchParams(action.query)
            : "";
          const picklist = params && params.get("picklist_nr");

          fileDownload(response.data, `${picklist || "picklist"}.csv`);
        }
        yield put(Actions.getPicklistItemsSuccess(response.data));
      } else {
        yield put(
          Actions.getPicklistItemsFailure(response.data.error || "Error")
        );
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getPicklistItemsFailure(error));
    }
  }
  function* watchGetPicklistItems(): Generator<void, void, void> {
    yield takeLatest(Types.GET_PICKLIST_ITEMS, getPicklistItems);
  }

  /*getReadyForPickup */
  function* getReadyForPickup(action) {
    try {
      const response = yield call(
        api.stockRequest.getReadyForPickup,
        action.query
      );

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getReadyForPickupSuccess(response.data));
        yield put(Actions.getStocksCount(action.query));
      } else {
        yield put(
          Actions.getReadyForPickupFailure(response.data.error || "Error")
        );
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getReadyForPickupFailure(error));
    }
  }
  function* watchGetReadyForPickup(): Generator<void, void, void> {
    yield takeLatest(Types.GET_READY_FOR_PICKUP, getReadyForPickup);
  }

  /*getReadyForPickup */
  function* getStocksCount(action) {
    try {
      const response = yield call(
        api.stockRequest.getStocksCount,
        action.query
      );

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getStocksCountSuccess(response.data));
      } else {
        yield put(
          Actions.getStocksCountFailure(response.data.error || "Error")
        );
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getStocksCountFailure(error));
    }
  }
  function* watchGetStocksCount(): Generator<void, void, void> {
    yield takeLatest(Types.GET_STOCKS_COUNT, getStocksCount);
  }

  /* createPicklist */
  function* createPicklist(action) {
    try {
      const response = yield call(
        api.stockRequest.createPicklist,
        action.payload
      );

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.createPicklistSuccess(response.data));
        toast(I18n.getText("stock-request.created-success"), {
          type: "success",
          className: "successClass"
        });
      } else {
        yield put(
          Actions.createPicklistFailure(response.data.error || "Error")
        );
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.createPicklistFailure(error));
    }
  }
  function* watchCreatePicklist(): Generator<void, void, void> {
    yield takeLatest(Types.CREATE_PICKLIST, createPicklist);
  }

  /* updatePicklistQty */
  function* updatePicklistQty(action) {
    try {
      const response = yield call(
        api.stockRequest.updatePicklistQty,
        action.payload
      );

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.updatePicklistQtySuccess(response.data));
        toast(I18n.getText("stock-request.updated-success"), {
          type: "success",
          className: "successClass"
        });
      } else {
        yield put(
          Actions.updatePicklistQtyFailure(response.data.error || "Error")
        );
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.updatePicklistQtyFailure(error));
    }
  }
  function* watchUpdatePicklistQty(): Generator<void, void, void> {
    yield takeLatest(Types.UPDATE_PICKLIST_QTY, updatePicklistQty);
  }

  /* markReadyForPickup */
  function* markReadyForPickup(action) {
    try {
      const response = yield call(
        api.stockRequest.markReadyForPickup,
        action.payload
      );

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.markReadyForPickupSuccess(response.data));
        toast(I18n.getText("stock-request.marked-success"), {
          type: "success",
          className: "successClass"
        });
      } else {
        yield put(
          Actions.markReadyForPickupFailure(response.data.error || "Error")
        );
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.markReadyForPickupFailure(error));
    }
  }
  function* watchMarkReadyForPickup(): Generator<void, void, void> {
    yield takeLatest(Types.MARK_READY_FOR_PICKUP, markReadyForPickup);
  }

  /* markReadyForPickup */
  function* markOutOfStock(action) {
    try {
      const response = yield call(
        api.stockRequest.markOutOfStock,
        action.payload
      );

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.markOutOfStockSuccess(response.data));
        if (action.noLoad) {
          toast(I18n.getText("stock-request.marked-oos-success"), {
            type: "success",
            className: "successClass"
          });
        }
      } else {
        yield put(
          Actions.markOutOfStockFailure(response.data.error || "Error")
        );
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.markOutOfStockFailure(error));
    }
  }
  function* watchMarkOutOfStock(): Generator<void, void, void> {
    yield takeLatest(Types.MARK_OUT_OF_STOCK, markOutOfStock);
  }

  return {
    watchGetRequests,
    watchCreatePicklist,
    watchGetPicklists,
    watchGetPicklistItems,
    watchMarkReadyForPickup,
    watchGetReadyForPickup,
    watchUpdatePicklistQty,
    watchGetStocksCount,
    watchMarkOutOfStock
  };
};



// WEBPACK FOOTER //
// ./src/sagas/StockRequestSaga.js